import {
  faFacebook,
  faInstagram,
  faLinkedinIn,
  faTwitter,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import "./../styles/SocialShare.style.css";

export default function SocialShare({
  title = "",
  link = "",
  desc = "IALM Academy",
}) {
  const message = `${title}\n\n${desc}\n\n${link}`;

  const encodedMessage = encodeURIComponent(message);
  const encodedTitle = encodeURIComponent(title);
  const encodedUrl = encodeURIComponent(link);
  const shareText = desc === "" ? "IALM" : `${desc}`;

  return (
    <>
      {/* Share Buttons */}
      <div className="social-share d-flex align-items-center mt-4 bg-white rounded-3 p-2">
        <h5 className="mb-0">Share with: </h5>
        <a
          href={`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}&quote=${encodedMessage}`}
          target="_blank"
          rel="noopener noreferrer"
          className="facebook"
          title="Share on Facebook"
          style={{ backgroundColor: "#3B5998" }}
        >
          <FontAwesomeIcon icon={faFacebook} />
        </a>

        <a
          href={`https://api.whatsapp.com/send?text=${encodedMessage}`}
          target="_blank"
          rel="noopener noreferrer"
          className="whatsapp"
          title="Share on WhatsApp"
          style={{ backgroundColor: "#25D366" }}
        >
          <FontAwesomeIcon icon={faWhatsapp} />
        </a>

        <a
          href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`}
          target="_blank"
          rel="noopener noreferrer"
          className="linkedin"
          title="Share on LinkedIn"
          style={{ backgroundColor: "#0077B5" }}
        >
          <FontAwesomeIcon icon={faLinkedinIn} />
        </a>

        <a
          href={`https://twitter.com/intent/tweet?text=${encodedMessage}`}
          target="_blank"
          rel="noopener noreferrer"
          className="twitter"
          title="Share on Twitter"
          style={{ backgroundColor: "#1DA1F2" }}
        >
          <FontAwesomeIcon icon={faTwitter} />
        </a>

        <a
          href="https://www.instagram.com/ialm_academy?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
          target="_blank"
          rel="noopener noreferrer"
          className="instagram"
          title="Follow on Instagram"
          style={{
            background: "#833ab4",
            backgroundImage: `linear-gradient(to right, #833ab4,#fd1d1d,#fcb045)`,
          }}
        >
          <FontAwesomeIcon icon={faInstagram} />
        </a>
      </div>
    </>
  );
}
